import { useState, useEffect } from "react";

import { ReactNode } from "react";
import { HeaderBar } from "./HeaderBar";
import useThemeStore, { isDarkMode } from "../../store/themeStore";
import { MainSidebar } from "./Sidebar";
import ContainerShell from "./ContainerShell";
import { useSeasonsStore } from "../../store/seasonsStore";
import { Busy } from "../Busy";
import { useNotificationsStore } from "../../store/notificationsStore";
import { ConfirmationDialogProvider } from "../ConfirmDialog";
import useInvitationStore from "../../store/invitationsStore";
import { MobileSideBar } from "./MobileSideBar";
import useAuthStore from "../../store/authStore";
import useWebSocketStore from "../../store/webSocketStore";

const MainShell = ({ children }: { children: ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isDm = useThemeStore(isDarkMode);
  const { currentSeason, getCurrentSeason, isBusy } = useSeasonsStore();
  const { fetchMyInvitations } = useInvitationStore();
  const { getAllNotifications } = useNotificationsStore();

  const { currentUser } = useAuthStore();
  const { connectWebSocket } = useWebSocketStore();

  useEffect(() => {
    getCurrentSeason();
    getAllNotifications();
  }, []);

  useEffect(() => {
    if (currentSeason) {
      fetchMyInvitations(currentSeason.id);
    }
  }, [currentSeason]);

  useEffect(() => {
    if (currentUser) {
      connectWebSocket(currentUser.email);
    }
  }, [currentUser]);

  return (
    <div
      className={`bg-cover bg-center bg-no-repeat bg-fixed w-full h-screen ${
        isDm ? "bg-dark" : "bg-light"
      }`}
    >
      <ConfirmationDialogProvider>
        <div>
          <MobileSideBar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            currentSeason={currentSeason}
            currentUser={currentUser}
          />

          <MainSidebar currentSeason={currentSeason} currentUser={currentUser} />

          <div className="main-content">
            <HeaderBar
              setSidebarOpen={setSidebarOpen}
              currentSeason={currentSeason}
            />
            <ContainerShell>{children}</ContainerShell>
          </div>

          {isBusy && <Busy busyMessage="" />}
        </div>
      </ConfirmationDialogProvider>
    </div>
  );
};

export default MainShell;